export default __webpack_public_path__ + "locales/ko-KR/ResetApplicationDialog.json?hash=64d0b76f67a657e7d4003656d667efef";